import { render, staticRenderFns } from "./provider-cases.vue?vue&type=template&id=7ec1279a"
import script from "./provider-cases.vue?vue&type=script&lang=js"
export * from "./provider-cases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports